export default "__VITE_ASSET__BxhNk3jg__"